import type { ColumnItem } from "../../../widgets/cards/CardInfoSection";

export type ObjectCardSectionOptions = {
    sectionName: string;
    columns: ColumnItem[][];
};

function distributeIntoColumns<T>(items: T[], columnsCount: number): T[][] {
    const columns: T[][] = Array.from({ length: columnsCount }, () => []);
    items.forEach((item, index) => {
        columns[index % columnsCount].push(item);
    });
    return columns;
}

export function buildObjectInfoCardStructure(apiSections: any[]): ObjectCardSectionOptions[] {
    if (!Array.isArray(apiSections)) return [];

    return apiSections.map((section: any) => {
        const sectionName: string = Object.keys(section)[0];
        const sectionItems: Record<string, string> = section?.data ?? {};

        const items: ColumnItem[] = Object.entries(sectionItems).map(([field, caption]) => ({
            format: 'field',
            caption: String(caption ?? ''),
            field,
        }));

        const columns = distributeIntoColumns(items, 4);

        return {
            sectionName,
            columns,
        };
    });
}


